'use client';

import { useContext, useMemo } from 'react';
import { FlagshipContext } from '@flagship.io/react-sdk';
import { useExperiment } from '../experiments/useExperiment';
import { SAMPLER_ALLOWED_PROMO_CODES } from '../experiments/constants';
import { DEFAULT_SAMPLER_ALLOWED_PROMO_CODES } from './constants';
import {
  isSamplerAllowlistReady,
  resolveSamplerAllowlist,
} from './samplerPromo';

export const useSamplerAllowlist = () => {
  const { value: samplerAllowedPromoCodes } = useExperiment(
    SAMPLER_ALLOWED_PROMO_CODES,
    DEFAULT_SAMPLER_ALLOWED_PROMO_CODES,
  );
  const { state: flagshipState } = useContext(FlagshipContext);

  return useMemo(
    () =>
      resolveSamplerAllowlist(
        isSamplerAllowlistReady(flagshipState?.modifications),
        samplerAllowedPromoCodes,
      ),
    [flagshipState?.modifications, samplerAllowedPromoCodes],
  );
};
